import styles from "../../../styles/Participant-Employment.module.css"
import { careerProfileLabels } from "../Types/careerProfileLabels"
import WorkGoals from "./Forms/WorkGoals"
import { Button } from "primereact/button"
import Education from "./Forms/Education/Education"
import { useEffect, useState, useRef } from "react"
import WorkExperience from "./Forms/WorkExperience/WorkExperience"
import MilitaryExperience from "./Forms/Military/MilitaryExperience"
import CulturalBackground from "./Forms/CulturalBackground"
import MentalHealth from "./Forms/MentalHealth"
import SubstanceUse from "./Forms/SubstanceUse"
import PhysicalHealth from "./Forms/PhysicalHealth"
import CognitiveHealth from "./Forms/CognitiveHealth"
import GettingReadyForAJob from "./Forms/GettingReadyForAJob"
import InterpersonalSkills from "./Forms/InterpersonalSkills"
import Benefits from "./Forms/Benefits"
import LegalHistory from "./Forms/Legal/LegalHistory"
import DailyActivities from "./Forms/DailyActivities"
import NetworkingContacts from "./Forms/NetworkingContacts"
import PastEducationExperiences from "./Forms/PastEducationExperiences/PastEducationExperiences"
import PlansForSchoolAndTraining from "./Forms/PlansForSchoolAndTraining/PlansForSchoolAndTraining"

const FormContent = ({
  activeForm,
  formik,
  setActiveForm,
  viewExtraEducationSections,
}) => {
  const [editEducationProgram, setEditEducationProgram] = useState()
  const [educationFormVisible, setEducationFormVisible] = useState(false)
  const [deleteEducationProgram, setDeleteEducationProgram] = useState()
  const [contactFormVisible, setContactFormVisible] = useState(false)
  const [editContact, setEditContact] = useState()
  const [deleteContact, setDeleteContact] = useState()
  const [editPastJob, setEditPastJob] = useState()
  const [pastJobFormVisible, setPastJobVisible] = useState(false)
  const [deletePastJob, setDeletePastJob] = useState()
  const [editConviction, setEditConviction] = useState()
  const [convictionFormVisible, setConvictionVisible] = useState(false)
  const [deleteConviction, setDeleteConviction] = useState()

  const scrollContainerRef = useRef(null)

  const setForm = (prevForm) => {
    const actualIndex = Object.entries(careerProfileLabels)
      .map((a) => a[1])
      .find((a) => a.title === activeForm)?.index
    if (prevForm) {
      return Object.entries(careerProfileLabels)
        .map((a) => a[1])
        .find((a) => a.index === actualIndex - 1).title
    }
    return Object.entries(careerProfileLabels)
      .map((a) => a[1])
      .find((a) => a.index === actualIndex + 1).title
  }
  const header = () => {
    return (
      <div className={styles.form_form_header}>
        <p className={styles.header_label}>{activeForm}</p>
        <div>
          <Button
            label="Back"
            style={{ marginRight: "1rem" }}
            className={styles.button}
            iconPos="left"
            icon="pi pi-angle-left"
            disabled={activeForm === careerProfileLabels.workGoals.title}
            onClick={() => {
              setActiveForm(setForm(true))
            }}
          />
          <Button
            label="Next"
            className={styles.button}
            iconPos="right"
            icon={"pi pi-angle-right"}
            onClick={() => {
              setActiveForm(setForm())
            }}
            disabled={
              activeForm === careerProfileLabels.networkingContacts.title
            }
          />
        </div>
      </div>
    )
  }
  const footer = () => {
    return (
      <div className={styles.form_form_footer}>
        <div>
          <Button
            label="Back"
            style={{ marginRight: "1rem" }}
            className={styles.button}
            iconPos="left"
            icon="pi pi-angle-left"
            disabled={activeForm === careerProfileLabels.workGoals.title}
            onClick={() => {
              setActiveForm(setForm(true))
            }}
          />
          <Button
            label="Next"
            className={styles.button}
            iconPos="right"
            icon={"pi pi-angle-right"}
            onClick={() => {
              setActiveForm(setForm())
            }}
            disabled={
              activeForm === careerProfileLabels.networkingContacts.title
            }
          />
        </div>
      </div>
    )
  }
  const removeEducationProgram = (id) => {
    formik.setFieldValue(
      "educationPrograms",
      formik.values.educationPrograms.filter((p) => p.id !== id)
    )
  }
  useEffect(() => {
    if (!viewExtraEducationSections) {
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_1.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_2.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_3.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_4.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_5.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_6.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_7.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_8.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_9.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_10.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_11.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_12.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_13.value,
        ""
      )
      formik.setFieldValue(
        careerProfileLabels.pastEducationExperiences.pastEducation_14.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_1.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_2.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_3.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4a.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_4b.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_5.value,
        {}
      )
      formik.setFieldValue(
        careerProfileLabels.plansForSchoolAndTraining.plansForSchool_6.value,
        {}
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewExtraEducationSections])
  const largeForm = () => {
    return (
      activeForm === careerProfileLabels.workGoals.title ||
      (activeForm === careerProfileLabels.education.title &&
        formik.values.education_6 === "Yes") ||
      activeForm === careerProfileLabels.pastEducationExperiences.title ||
      activeForm === careerProfileLabels.plansForSchoolAndTraining.title ||
      (activeForm === careerProfileLabels.militaryExperience.title &&
        formik.values.military_1 === "Yes") ||
      activeForm === careerProfileLabels.culturalBackground.title ||
      activeForm === careerProfileLabels.mentalHealth.title ||
      activeForm === careerProfileLabels.substanceUse.title ||
      activeForm === careerProfileLabels.physicalHealth.title ||
      activeForm === careerProfileLabels.cognitiveHealth.title ||
      activeForm === careerProfileLabels.interpersonalSkills.title ||
      (activeForm === careerProfileLabels.legalHistory.title &&
        formik.values.legal_3 === "Yes") ||
      activeForm === careerProfileLabels.dailyActivities.title
    )
  }
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0
    }
  }, [activeForm])

  return (
    <div className={styles.careerProfile_form} ref={scrollContainerRef}>
      <div style={{ position: "relative", overflowY: "auto" }}>
        {header()}
        {activeForm === careerProfileLabels.workGoals.title && (
          <WorkGoals formik={formik} />
        )}
        {activeForm === careerProfileLabels.education.title && (
          <Education
            formik={formik}
            deleteEducationProgram={deleteEducationProgram}
            editEducationProgram={editEducationProgram}
            educationFormVisible={educationFormVisible}
            removeEducationProgram={removeEducationProgram}
            setDeleteEducationProgram={setDeleteEducationProgram}
            setEditEducationProgram={setEditEducationProgram}
            setEducationFormVisible={setEducationFormVisible}
            viewExtraEducationSections={viewExtraEducationSections}
          />
        )}
        {activeForm === careerProfileLabels.pastEducationExperiences.title && (
          <PastEducationExperiences formik={formik} />
        )}
        {activeForm === careerProfileLabels.plansForSchoolAndTraining.title && (
          <PlansForSchoolAndTraining formik={formik} />
        )}
        {activeForm === careerProfileLabels.workExperience.title && (
          <WorkExperience
            formik={formik}
            editPastJob={editPastJob}
            setEditPastJob={setEditPastJob}
            deletePastJob={deletePastJob}
            pastJobFormVisible={pastJobFormVisible}
            setDeletePastJob={setDeletePastJob}
            setPastJobFormVisible={setPastJobVisible}
          />
        )}
        {activeForm === careerProfileLabels.militaryExperience.title && (
          <MilitaryExperience formik={formik} />
        )}
        {activeForm === careerProfileLabels.culturalBackground.title && (
          <CulturalBackground formik={formik} />
        )}
        {activeForm === careerProfileLabels.mentalHealth.title && (
          <MentalHealth formik={formik} />
        )}
        {activeForm === careerProfileLabels.substanceUse.title && (
          <SubstanceUse formik={formik} />
        )}
        {activeForm === careerProfileLabels.physicalHealth.title && (
          <PhysicalHealth formik={formik} />
        )}
        {activeForm === careerProfileLabels.cognitiveHealth.title && (
          <CognitiveHealth formik={formik} />
        )}
        {activeForm === careerProfileLabels.gettingReadyJob.title && (
          <GettingReadyForAJob formik={formik} />
        )}
        {activeForm === careerProfileLabels.interpersonalSkills.title && (
          <InterpersonalSkills formik={formik} />
        )}
        {activeForm === careerProfileLabels.benefits.title && (
          <Benefits formik={formik} />
        )}
        {activeForm === careerProfileLabels.legalHistory.title && (
          <LegalHistory
            formik={formik}
            editConviction={editConviction}
            setEditConviction={setEditConviction}
            deleteConviction={deleteConviction}
            convictionFormVisible={convictionFormVisible}
            setDeleteConviction={setDeleteConviction}
            setConvictionFormVisible={setConvictionVisible}
          />
        )}
        {activeForm === careerProfileLabels.dailyActivities.title && (
          <DailyActivities formik={formik} />
        )}
        {activeForm === careerProfileLabels.networkingContacts.title && (
          <NetworkingContacts
            formik={formik}
            contactFormVisible={contactFormVisible}
            setContactFormVisible={setContactFormVisible}
            editContact={editContact}
            setEditContact={setEditContact}
            deleteContact={deleteContact}
            setDeleteContact={setDeleteContact}
          />
        )}
        {largeForm() && footer()}
      </div>
    </div>
  )
}
export default FormContent
